// extracted by mini-css-extract-plugin
module.exports = {"legalWrapper":"LegalArea__legalWrapper__3otOj","legal":"LegalArea__legal__35D41"};